module.exports = __webpack_public_path__ + "static/media/kit_LEDMiniBox.0d471ef7.png";